import Api from '@utils/api';
import { Configuraciones } from '@constants/urls';

export const state = {
	loading: true,
	fullscreen: false,
	screenRecorder: false,
	cameraRecorder: false,
	configuracionCargada: false,
	nombrePlantel: '',
	logoPlantel: '',
	plantel: '',
	zonaHoraria: null
	// mensajeBanner: ''
};

export const getters = {
	getEnableFullScreen: function(state) {
		return state.fullscreen;
	},
	getEnableScreenRecorder: function(state) {
		return state.screenRecorder;
	},
	getEnableCameraRecorder: function(state) {
		return state.cameraRecorder;
	},
	getConfiguracionCargada: function(state) {
		return state.configuracionCargada;
	},
	getLogoPlantel: function(state) {
		return state.logoPlantel;
	},
	getNombrePlantel: function(state) {
		return state.nombrePlantel;
	},
	getPlantel: function(state) {
		return state.plantel;
	},
	getZonaHoraria: function(state) {
		return state.zonaHoraria;
	},
	getLoading: function(state) {
		return state.loading;
	},
	getConfiguracion: function(state) {
		return state;
	}
	// getMensajeBanner: function(state) {
	// 	return state.mensajeBanner;
	// }
};

export const mutations = {
	SET_CONFIGURACION: function(state, newValue) {
		state.fullscreen = newValue.fullscreen;
		state.screenRecorder = newValue.screenRecorder;
		state.cameraRecorder = newValue.cameraRecorder;
		state.configuracionCargada = newValue.configuracionCargada;
		state.logoPlantel = newValue.logoPlantel;
		state.nombrePlantel = newValue.nombrePlantel;
		state.zonaHoraria = newValue.timeZone;
		state.plantel = newValue.plantel;
		// state.mensajeBanner = newValue.mensajeBanner;
	},
	SET_LOADING: function(state, newValue) {
		state.loading = newValue;
	}
};

export const actions = {
	obtener({ commit }) {
		commit('SET_LOADING', true);
		Api.Get(Configuraciones.OBTENER)
			.then((response) => {
				commit('SET_CONFIGURACION', {
					...response.data.data,
					configuracionCargada: true
				});
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	}
};
